export default "static/dist/img/info-filled.svg?7099bfbb923c686acfe26610c18a7d3c";